import TeaserBaseView from './TeaserBaseView';
import * as config from '../../home24/core/config';

export default TeaserBaseView.extend({
  events: {
    'click .ui-slider-to-left': 'onClickToTheLeft',
    'click .ui-slider-to-right': 'onClickToTheRight',
    'touchstart .content': 'onTouchStart',
    'touchend .content': 'onTouchEnd'
  },

  /**
   * @type {Number}
   */
  fadeTime: config.getInt('marketing.teaser.sliding.intervals.fade'),

  /**
   * @type {int}
   */
  previousTeaser: 0,

  onTimeout: function() {
    if (!this.blockTransition) {
      this.onClickToTheRight();
    }
  },

  toGlobalFallback: function() {
    this.$('.ui-slider-to-left').hide();
    this.$('.ui-slider-to-right').hide();
  },

  onClickToTheLeft: function() {
    this.fadeTo(this.getPrevTeaser());
    this.restartTimer();
  },

  onClickToTheRight: function() {
    this.fadeTo(this.getNextTeaser());
    this.restartTimer();
  },

  /**
   * @param {int} target
   */
  fadeTo: function(target) {
    var $active = this.$teasers.eq(this.activeTeaser);
    var $new = this.$teasers.eq(target);

    if (this.activeTeaser !== target) {
      $active.fadeOut(this.fadeTime);
    }

    this.activeTeaser = target;
    $new.fadeIn(this.fadeTime);

    this.postFadeTo();
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/TeaserFadeView.js
 **/